import request from '@/utils/request'

export function getAllType() {
  return request({
    url: 'administration/getAllType',
    method: 'get',
  });
}
